// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1BxNA","largestCol":"styles_largestCol__3WRFj","smallestCol":"styles_smallestCol__1i5Ic"};